import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
/**
 * Shared "must be logged in" / "must have permission" gates for
 * /species-corrections (champis-species.manage) and /missing-species
 * (champis-species.viewMissingSpecies) - both moderation-only pages whose
 * own API resources reject anyone without that permission (see
 * MissingSpeciesResource/AcceptedSpeciesResource etc.'s own endpoints()),
 * which each page's own load() previously surfaced as the same generic
 * "une erreur est survenue" placeholder for a guest AND for a logged-in
 * member who simply isn't a curator - indistinguishable from a real
 * failure either way.
 *
 * The two cases need different treatment: a guest might still gain access
 * once logged in (they could be a curator who forgot to sign in), so
 * promptLogin()/loginRequiredPlaceholder() make sense there - but a
 * logged-in non-curator's problem isn't authentication at all, logging in
 * again wouldn't help, so permissionDeniedPlaceholder() below is a plain
 * message with no call to action. Each page's own oninit() checks
 * app.session.user first, then its own canManageSpecies/
 * canViewMissingSpecies forum attribute, to pick the right one.
 */
export function promptLogin() {
  // setTimeout is required, not incidental - see champis-exhibitions'
  // own requireLogin.js for the full "Node is currently being rendered
  // to" story this avoids when called from a lifecycle method like
  // oninit.
  setTimeout(() => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal')));
}
export function loginRequiredPlaceholder(text) {
  return m("div", {
    className: "Placeholder"
  }, m("p", null, text), m(Button, {
    className: "Button Button--primary",
    onclick: promptLogin
  }, app.translator.trans('core.forum.log_in.submit_button')));
}
export function permissionDeniedPlaceholder(text) {
  return m("div", {
    className: "Placeholder"
  }, m("p", null, text));
}
flarum.reg.add('champis-species', 'forum/utils/requireAccess', { promptLogin: promptLogin,loginRequiredPlaceholder: loginRequiredPlaceholder,permissionDeniedPlaceholder: permissionDeniedPlaceholder, });